import React, { useEffect, useState } from "react";
import "./completeOrderCardStyle.css";
import { useSelector } from "react-redux";
import ColumnBackgroundMedia from "../columnBackgroundMedia/ColumnBackgroundMedia";

const CompleteOrderCard = () => {
  const { fontSize, fontColor, backgroundColor, readyBG ,kotTokenData, readyColumnBgEnabled, readyColumnBgOpacity, readyColumnBgMediaIds, columnBgIntervalMs } = useSelector(
    (state) => state.kotTokenDisplaySlice
  );
  const rawData = kotTokenData?.completed;
    const data = Array.isArray(rawData) ? rawData : [];
  const fontSizeStyles =
    fontSize === "xlarge"
      ? { fontSize: "46px" }
      : fontSize === "large"
      ? { fontSize: "38px" }
      : { fontSize: "30px" };
  const columns = fontSize === "large" || fontSize === "xlarge" ? 2 : 3;
  
  // autoscroll
const chunkSize = fontSize === "xlarge" ? 16 : fontSize === "medium" ? 36 : 20;
const totalChunks = Math.ceil(data.length / chunkSize);
const [currentChunk, setCurrentChunk] = useState(0);

// Get the current data slice
const chunkData = data.slice(
  currentChunk * chunkSize,
  currentChunk * chunkSize + chunkSize
);
useEffect(() => {
  if (data.length <= chunkSize) return;
  const interval = setInterval(() => {
    setCurrentChunk((prev) => (prev + 1) % totalChunks);
  }, 7000); // scroll every 10 seconds
  return () => clearInterval(interval);
}, [data.length, chunkSize]);



  return (
    <div className="token-display-completed-order-container">
      <div className="order-status-type-container">
        <h3 className="token-display-status-header">READY</h3>
      </div>
      <div
        style={{ backgroundColor: readyBG, height: "-webkit-fill-available", position: "relative", overflow: "hidden" }}
      >
        {readyColumnBgEnabled && Array.isArray(readyColumnBgMediaIds) && readyColumnBgMediaIds.length > 0 && (
          <ColumnBackgroundMedia mediaIds={readyColumnBgMediaIds} opacityPercent={readyColumnBgOpacity} intervalMs={columnBgIntervalMs} />
        )}
        <div
          className="token-status-card-body"
          style={{
            ...fontSizeStyles,
            display: "grid",
            gridTemplateColumns: `repeat(${columns}, 1fr)`,
            gap: fontSize === "xlarge" ? "14px" : "12px",
            padding: fontSize === "xlarge" ? "14px" : "10px",
            position: "relative",
            zIndex: 1,
          }}
        >
          {chunkData?.map((res, i) => (
            <div
              key={i}
              className="token-number-box"
              style={{
                textAlign: "center",
                backgroundColor: backgroundColor,
                color: fontColor,
              }}
            >
              {res?.transNo}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CompleteOrderCard;
